<template>
  <div>
    <v-card
      flat
      class="pt-4"
    >
      <div
        v-if="this.member_information.id!=null && (position==='ADMIN'||position==='HUMAN RESOURCE'||position==='EXECUTIVE')">
        <v-layout v-if="this.member_information.is_active===1">
          <v-flex xs12 md3>
            <v-btn outlined
              class="w-full"
              color="primary"
              @click="is_change_salary=true"
              v-if="!is_change_salary"
            >
              Add Memo
            </v-btn>
            <v-progress-circular
              :size=50
              :width="5"
              color="primary"
              indeterminate
              v-else
            ></v-progress-circular>
          </v-flex>
        </v-layout>
      </div>

      <v-simple-table dense class="pt-2">
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-uppercase">
              Subject
            </th>
            <th class="text-uppercase">
              Released On
            </th>
            <th class="text-uppercase">
              Grounds
            </th>
            <th class="text-uppercase">
              Released By
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="item in data"
            :key="item.id"
          >
            <td>
              {{ item.subject}}
            </td>
            <td>
              {{ item.date_of_release }}
            </td>
            <td>
              {{ item.grounds }}
            </td>
            <td>
              {{ item.employee_released.last_name+', '+item.employee_released.first_name }}
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-dialog v-model="is_change_salary" persistent max-width="30%">
      <AddMemo :member_information="member_information"
               v-on:response="on_change"></AddMemo>
      <v-btn color="error" @click="is_change_salary = false"> Close</v-btn>
    </v-dialog>
    <snack-bar-dialog
      :snackbar_flag="this.snackbar"
      :color="this.snackbar_color"
      :snackbar_text="this.snackbar_text"
    />
  </div>
</template>

<script>
  import {
    mdiPlusBox,
    mdiThumbUp,
    mdiThumbDown,
  } from '@mdi/js'
  import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'
  import AddMemo from "@/views/file_interface/search/components_emloyee/components/AddMemo";
  import {mapActions, mapGetters} from "vuex";

  export default {
    props: {
      member_information: Object,
      data: Array,
    },
    components: {
      AddMemo,
      snackBarDialog,
    },
    setup() {
      return {
        icons: {
          mdiPlusBox,
          mdiThumbUp,
          mdiThumbDown,
        },
      }
    },
    data() {
      return {
        is_change_salary: false,
      }
    },
    computed: {
      ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text']),
      ...mapGetters('authentication', ['employee_id', 'position']),
    },
    methods: {
      ...mapActions('system_data', ['change_snackbar']),
      ...mapActions('employee_compensation_history', ['approve_compensation']),
      formatPrice(value) {
        let val = (value / 1).toFixed(2).replace(',', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      on_change(value) {
        var color = 'error'
        if (value.status === 200) {
          color = 'success'
        }
        this.change_snackbar({
          show: true,
          color: color,
          text: value.data,
        })
        this.is_change_salary = false
      },
    }
  }
</script>
